import { Controller } from 'stimulus';

export default class extends Controller {
  initialize() {
    this.planId =
      this.element.dataset.annuallySeatPlan || 'Annual Premium (84$/month)';
    const publishableKey = $('#stripe-key').val();
    this.stripe = Stripe(publishableKey);
    this.initialPrice = 0;
    this.stripeElements();
  }

  getPlanId() {
    let plan = localStorage['selected_plan']
    localStorage.removeItem('selected_plan')
    return plan || this.planId
  }

  selectedPlanAnually() {
    let selectedPlan = ''
    if (this.element.dataset.planType === 'individuals') {
      selectedPlan = 'Annual Premium (84$/month)'
    } else {
      selectedPlan = 'Seats Annually Premium (60$/month)'
    }
    localStorage.setItem('selected_plan', selectedPlan);
  }

  selectedPlanMonthly() {
    let selectedPlan = ''
    if (this.element.dataset.planType === 'individuals') {
      selectedPlan = 'Monthly Premium (99$)'
    } else {
      selectedPlan = 'Seats Monthly Premium (85$)'
    }
    localStorage.setItem('selected_plan', selectedPlan);
  }

  stripeElements() {
    const elements = this.stripe.elements({
      fonts: [
        {
          cssSrc: 'https://rsms.me/inter/inter-ui.css'
        }
      ],
      locale: 'auto'
    });
    const style = {
      base: {
        fontWeight: 500,
        fontSize: '16px',
        fontSmoothing: 'antialiased',

        '::placeholder': {
          color: '#CFD7DF'
        }
      },
      invalid: {
        color: '#E25950'
      }
    };
    this.cardContent(elements, style);
  }

  cardContent(elements, style) {
    this.cardElement = elements.create('card', { style });
    this.cardElement.mount('#card-element');

    this.cardElement.addEventListener('change', ({ error }) => {
      const displayError = $('#card-errors')[0];
      if (error) {
        displayError.textContent = error.message;
      } else {
        displayError.textContent = '';
      }
    });
  }

  async submitBtn(event) {
    event.preventDefault();
    if (this.validateInputs()) {
      return false;
    }

    const { token, error } = await this.stripe.createToken(this.cardElement);
    if (error) {
      const errorElement = $('#card-errors')[0];
      errorElement.textContent = error.message;
      return false;
    } else {
      $('#subscription-btn').attr('disabled', true);
      $('#skip-btn').attr('disabled', true);
      $('#token-hidden').val(token.id);
      $('#plan-hidden').val(this.getPlanId());
      $('#payment-form')[0].submit();
    }
}

  validateInputs() {
      $('#name-error').text('');
      $('#postal-error').text('');
      $('#email-error').text('');
      $('#card-holder-name').css('margin-bottom', '1rem');
      $('#postal-code').css('margin-bottom', '1rem');
      let cardName = $('#card-holder-name').val();
      let postalCode = $('#postal-code').val();
      let hasErrors = false;

      if (!/^[a-zA-Z\s]*$/.test(cardName)) {
          $('#name-error').text('Card Holder Name should contain only alphabetic characters.');
          $('#card-holder-name').css('margin-bottom', '0px');
          hasErrors = true;
      }

      if (!/^[0-9]*$/.test(postalCode)) {
          $('#postal-error').text('Postal Code should be numeric.');
          $('#postal-code').css('margin-bottom', '0px');
          hasErrors = true;
      }

      return hasErrors;
  }

  async previousSubmitBtn(event) {
    event.preventDefault();
    $("#subscription-btn").attr("disabled", true);
    const plan_field = $("#plan-hidden");
    if (!plan_field.val()) {
      plan_field.val(this.getPlanId());
    }
    $("#payment-form")[0].submit();
  }

  handleModelClose(event) {
    if (window.location.href.includes("success")) {
      window.location.href = window.location.pathname;
      window.location.reload();
    }
  }

  async applyCoupon() {
    const code = document.querySelector('.coupon-val')?.value
    if (!code) return;

    this.showLoading();
    try {
      const originalPrice = parseFloat(document.querySelector('.due-amount').innerText.replace(/[^\d.-]/g, ''));
      this.initialPrice = originalPrice;
      const response = await fetch(`/subscriptions/validate_coupon?code=${code}`);
      const data = await response.json();
      if (data.valid) {
        const discount = data.percent_off
          ? originalPrice * (data.percent_off / 100)
          : data.amount_off;

        const discountedPrice = (originalPrice - discount) / 100;
        $('.discount-amount').text(`${data.percent_off ? `${data.percent_off}%` : `${data.amount_off}$` }`);
        $('.remove-discount').removeClass('is-hidden');
        $('.due-amount').text(`$${discountedPrice.toFixed(2)}`);
      } else {
        alert('Invalid or expired coupon code.');
      }
    } catch (error) {
      console.error('Coupon check failed:', error);
      alert('Something went wrong while validating coupon.');
    } finally {
      this.hideLoading();
    }
  }

  async removeCoupon() {
    $('.discount-amount').text('');
    $('.due-amount').text(`$${this.initialPrice}`);
    $('.coupon-val').val('');
    $('.remove-discount').addClass('is-hidden');
  }

  showLoading() {
    document.querySelector('.loading-overlay')?.classList.remove('hidden');
    document.querySelectorAll('input, button, select').forEach(el => el.setAttribute('disabled', 'true'));
  }

  hideLoading() {
    document.querySelector('.loading-overlay')?.classList.add('hidden');
    document.querySelectorAll('input, button, select').forEach(el => el.removeAttribute('disabled'));
  }
}
